// extracted by mini-css-extract-plugin
export default {"contents":"styles_contents__+QUpL","titleArea":"styles_titleArea__qZKdG","txtArea":"styles_txtArea__COxYI","buttonArea":"styles_buttonArea__yzDyS"};